<div class="custom-snackbar">
  <button
    mat-icon-button
    type="button"
    (click)="dismiss()"
  >
    <mat-icon>close</mat-icon>
  </button>
  <span class="mt-1">{{ message | translate }}</span>
  @if (information) {
    <span>"{{ information }}"</span>
  }
</div>
